import { PageType, PredefinedFixedPageConfig } from '../../../types'

export enum OnlineFixedPageEnum {
  OnlineHomeCurrent = 'online_home-current',
  OnlineHomeElectrified = 'online_home-electrified',
  OnlineHomeSystem = 'online_home-system',
  // OnlineEnergySatellite = 'online_energy-satellite',
  // OnlineEnergyCurrent = 'online_energy-current',
  // OnlineEnergyElectrified = 'online_energy-electrified',
  OnlineEnergy = 'online_energy',
  OnlineSavingsCurrentNow = 'online_savings-current-now',
  OnlineSavingsCurrentFuture = 'online_savings-current-future',
  OnlineSavingsCurrentCumulative = 'online_savings-current-cumulative',
  OnlineSavingsElectrifiedNow = 'online_savings-electrified-now',
  OnlineSavingsElectrifiedFuture = 'online_savings-electrified-future',
  OnlineSavingsElectrifiedCumulative = 'online_savings-electrified-cumulative',
  OnlineGoDisclaimers = 'online_go-disclaimers',
  OnlineGoCheckout = 'online_go-checkout',
}

/** Legacy ids removed in template 3.2; used only for migrating stored templates. */
export const LEGACY_ONLINE_GO_DISCLAIMERS_PAGE_IDS = ['online_go-disclaimers-1', 'online_go-disclaimers-2'] as const

export const AVAILABLE_FIXED_PAGE_IDS: string[] = Object.values(OnlineFixedPageEnum)

export const ONLINE_FIXED_PAGES_DESIGN: Record<OnlineFixedPageEnum, any> = {
  [OnlineFixedPageEnum.OnlineHomeCurrent]: {
    frames: [
      {
        attributes: {
          id: 'ivl8y',
        },
        component: {
          type: 'wrapper',
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'home-chapter',
              type: 'home-chapter',
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        tagName: 'home-chapter',
        type: 'home-chapter',
        id: 'qGkvIYfM4LHq3JNd',
      },
    ],
    id: OnlineFixedPageEnum.OnlineHomeCurrent,
    name: 'Home:Current',
  },
  [OnlineFixedPageEnum.OnlineHomeElectrified]: {
    name: 'Home:Electrified',
    frames: [
      {
        attributes: {
          id: 'ivl8y',
        },
        component: {
          type: 'wrapper',
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'home-chapter',
              type: 'home-chapter',
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        tagName: 'home-chapter',
        type: 'home-chapter',
        id: 'ZOHA57xHykU0F648',
      },
    ],
    id: OnlineFixedPageEnum.OnlineHomeElectrified,
  },
  [OnlineFixedPageEnum.OnlineHomeSystem]: {
    name: 'Home:System',
    frames: [
      {
        attributes: {
          id: 'ivl8da',
        },
        component: {
          type: 'wrapper',
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'home-chapter-system',
              type: 'home-chapter-system',
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        tagName: 'home-chapter-system',
        type: 'home-chapter-system',
        id: 'VWdjB73CzAjUVcVga',
      },
    ],
    id: OnlineFixedPageEnum.OnlineHomeSystem,
  },
  [OnlineFixedPageEnum.OnlineEnergy]: {
    name: 'Energy Page',
    frames: [
      {
        attributes: {
          id: 'ivl8zc',
        },
        component: {
          type: 'wrapper',
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          attributes: {
            id: 'ijhja',
          },
          components: [
            {
              tagName: 'energy-chapter',
              type: 'energy-chapter',
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        tagName: 'energy-chapter',
        type: 'energy-chapter',
        id: 'mR8wP2nX7KjF9QvE',
      },
    ],
    id: OnlineFixedPageEnum.OnlineEnergy,
  },
  // [OnlineFixedPageEnum.OnlineEnergySatellite]: {
  //   name: 'Energy:Satellite',
  //   frames: [
  //     {
  //       attributes: {
  //         id: 'ivl8zc',
  //       },
  //       component: {
  //         type: 'wrapper',
  //         stylable: [
  //           'background',
  //           'background-color',
  //           'background-image',
  //           'background-repeat',
  //           'background-attachment',
  //           'background-position',
  //           'background-size',
  //         ],
  //         attributes: {
  //           id: 'ijhja',
  //         },
  //         components: [
  //           {
  //             tagName: 'energy-chapter',
  //             type: 'energy-chapter',
  //           },
  //         ],
  //         head: {
  //           type: 'head',
  //         },
  //         docEl: {
  //           tagName: 'html',
  //         },
  //       },
  //       tagName: 'energy-chapter',
  //       type: 'energy-chapter',
  //       id: 'mR8wP2nX7KjF9QvE',
  //     },
  //   ],
  //   id: OnlineFixedPageEnum.OnlineEnergySatellite,
  // },
  // [OnlineFixedPageEnum.OnlineEnergyCurrent]: {
  //   name: 'Energy:Current',
  //   frames: [
  //     {
  //       attributes: {
  //         id: 'ivl8za',
  //       },
  //       component: {
  //         type: 'wrapper',
  //         stylable: [
  //           'background',
  //           'background-color',
  //           'background-image',
  //           'background-repeat',
  //           'background-attachment',
  //           'background-position',
  //           'background-size',
  //         ],
  //         components: [
  //           {
  //             tagName: 'energy-chapter',
  //             type: 'energy-chapter',
  //           },
  //         ],
  //         head: {
  //           type: 'head',
  //         },
  //         docEl: {
  //           tagName: 'html',
  //         },
  //       },
  //       tagName: 'energy-chapter',
  //       type: 'energy-chapter',
  //       id: 'qGkvIYfM4LHq3JNda',
  //     },
  //   ],
  //   id: OnlineFixedPageEnum.OnlineEnergyCurrent,
  // },
  // [OnlineFixedPageEnum.OnlineEnergyElectrified]: {
  //   name: 'Energy:Electrified',
  //   frames: [
  //     {
  //       attributes: {
  //         id: 'ivl8yb',
  //       },
  //       component: {
  //         type: 'wrapper',
  //         stylable: [
  //           'background',
  //           'background-color',
  //           'background-image',
  //           'background-repeat',
  //           'background-attachment',
  //           'background-position',
  //           'background-size',
  //         ],
  //         components: [
  //           {
  //             tagName: 'energy-chapter',
  //             type: 'energy-chapter',
  //           },
  //         ],
  //         head: {
  //           type: 'head',
  //         },
  //         docEl: {
  //           tagName: 'html',
  //         },
  //       },
  //       tagName: 'energy-chapter',
  //       type: 'energy-chapter',
  //       id: 'ZOHA57xHykU0F648b',
  //     },
  //   ],
  //   id: OnlineFixedPageEnum.OnlineEnergyElectrified,
  // },
  [OnlineFixedPageEnum.OnlineSavingsCurrentNow]: {
    name: 'Savings:Current:Now',
    frames: [
      {
        component: {
          type: 'wrapper',
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'savingspage',
              type: 'SavingsPage',
              attributes: {
                class: ['proposal-background'],
              },
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        id: 'l6jpkxC2K6G0k7dN',
      },
    ],
    id: OnlineFixedPageEnum.OnlineSavingsCurrentNow,
  },
  [OnlineFixedPageEnum.OnlineSavingsCurrentFuture]: {
    name: 'Savings:Current:Future',
    frames: [
      {
        component: {
          type: 'wrapper',
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'savingspage',
              type: 'SavingsPage',
              attributes: {
                class: ['proposal-background'],
              },
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        id: 'McAX674M74HdpSDS',
      },
    ],
    id: OnlineFixedPageEnum.OnlineSavingsCurrentFuture,
  },
  [OnlineFixedPageEnum.OnlineSavingsCurrentCumulative]: {
    name: 'Savings:Current:Cumulative',
    frames: [
      {
        component: {
          type: 'wrapper',
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'savingspage',
              type: 'SavingsPage',
              attributes: {
                class: ['proposal-background'],
              },
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        id: 'CHrBbVadsS628HNl',
      },
    ],
    id: OnlineFixedPageEnum.OnlineSavingsCurrentCumulative,
  },
  [OnlineFixedPageEnum.OnlineSavingsElectrifiedNow]: {
    name: 'Savings:Elec:Now',
    frames: [
      {
        component: {
          type: 'wrapper',
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'savingspage',
              type: 'SavingsPage',
              attributes: {
                class: ['proposal-background'],
              },
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        id: 'CKdRJn9lOCt2uEsu',
      },
    ],
    id: OnlineFixedPageEnum.OnlineSavingsElectrifiedNow,
  },
  [OnlineFixedPageEnum.OnlineSavingsElectrifiedFuture]: {
    name: 'Savings:Elec:Future',
    frames: [
      {
        component: {
          type: 'wrapper',
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'savingspage',
              type: 'SavingsPage',
              attributes: {
                class: ['proposal-background'],
              },
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        id: 'wIQZzcuqIwYi6yTG',
      },
    ],
    id: OnlineFixedPageEnum.OnlineSavingsElectrifiedFuture,
  },
  [OnlineFixedPageEnum.OnlineSavingsElectrifiedCumulative]: {
    name: 'Savings:Elec:Cumulative',
    frames: [
      {
        component: {
          type: 'wrapper',
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'savingspage',
              type: 'SavingsPage',
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        id: 'mqvyZZcAIEI5efHG',
      },
    ],
    id: OnlineFixedPageEnum.OnlineSavingsElectrifiedCumulative,
  },
  [OnlineFixedPageEnum.OnlineGoCheckout]: {
    name: 'Go:Checkout',
    frames: [
      {
        component: {
          type: 'wrapper',
          badgable: false,
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          highlightable: false,
          selectable: false,
          components: [
            {
              tagName: 'online_go-checkout',
              type: 'online_go-checkout',
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        id: '4VlQqZAHiP9GvRvu',
      },
    ],
    id: OnlineFixedPageEnum.OnlineGoCheckout,
  },
  [OnlineFixedPageEnum.OnlineGoDisclaimers]: {
    name: 'Disclaimers',
    frames: [
      {
        component: {
          type: 'wrapper',
          badgable: false,
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          highlightable: false,
          selectable: false,
          components: [
            {
              tagName: 'disclaimers',
              type: 'disclaimers',
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        id: '5VqQqZwHiPrGvRvu',
      },
    ],
    id: OnlineFixedPageEnum.OnlineGoDisclaimers,
  },
}

export const FIXED_PAGE_CONFIGS: PredefinedFixedPageConfig[] = Object.values(OnlineFixedPageEnum).map((id) => {
  return {
    type: PageType.PredefinedFixedPage,
    pageId: id,
  }
})
